module.exports = __webpack_public_path__ + "img/YT1.804d748a.png";